import { ca } from '@cian/analytics';

interface IProjectsProduct {
  id: number;
  offerType: 'CSP';
  position: number;
}

export function trackSuggestShow(products: IProjectsProduct[]): void {
  ca('eventSite', {
    action: 'show_sopr',
    category: 'land_card',
    label: 'suburban_csp',
    event: 'oldevent',
    products,
  });
}

export function trackProjectClick(id: number, position: number): void {
  ca('eventSite', {
    action: 'Click_sopr',
    category: 'land_card',
    label: 'suburban_csp',
    name: 'oldevent',
    products: [
      {
        id,
        offerType: 'CSP',
        position,
      },
    ],
  });
}

export function trackAllProjectsClick(): void {
  ca('eventSite', {
    action: 'show_all_sopr',
    category: 'land_card',
    label: 'suburban_csp',
    name: 'oldevent',
    useLastProducts: true,
  });
}
